import Link from 'next/link';
import styled from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';
import { DESKTOP_WIDTH } from '~constant/layout';

export const S = {
  FooterContainer: styled.footer`
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.colors.gray400};
    background: #fff;
  `,
  FooterWarpper: styled.div`
    width: ${DESKTOP_WIDTH}px;
    display: flex;
    flex-direction: column;
    padding: 32px 0;
    margin: 0 auto;

    ${({ theme }) => theme.media.with('mobile', 'tablet')} {
      width: 100%;
    }
    ${({ theme }) => theme.media.tablet} {
      padding: 32px;
    }

    ${({ theme }) => theme.media.mobile} {
      padding: 16px;
    }
  `,
  MenuWrapper: styled.div`
    display: flex;
    align-items: center;
    gap: 40px;
    margin-bottom: 32px;

    ${({ theme }) => theme.media.mobile} {
      gap: 20px;
    }
  `,
  MenuItem: styled.span`
    color: ${({ theme }) => theme.colors.gray900};
    white-space: nowrap;

    cursor: pointer;
    ${getFontStyle('bold150_B3')};
  `,
  Content: styled(Text)`
    color: ${({ theme }) => theme.colors.gray700};
  `,
  SubContent: styled(Text)`
    color: ${({ theme }) => theme.colors.gray900};
    margin-top: 10px;
  `,
};
